module.exports = __webpack_public_path__ + "img/agenda_05.e63e132e.jpg";